module.exports = __webpack_public_path__ + "img/concern@2x.0a55040.png";